// nav.js generateHelpjuiceJwt()/replaceHelpjuiceLocale(): copied verbatim. externis.helpjuiceSecret
// is already served in plaintext to the browser (fetched from a settings API response, read directly
// off `externis`, never encapsulated in a VM), so signing this JWT in Vue introduces no new exposure.
export async function generateHelpjuiceJwt(email, secret) {
	const enc = new TextEncoder();
	const header = { alg: 'HS256', typ: 'JWT' };
	const payload = { jti: crypto.randomUUID(), iat: Date.now(), email };

	const base64url = (buf) =>
		btoa(String.fromCharCode(...new Uint8Array(buf)))
			.replace(/=/g, '')
			.replace(/\+/g, '-')
			.replace(/\//g, '_');

	const headerB64 = base64url(enc.encode(JSON.stringify(header)));
	const payloadB64 = base64url(enc.encode(JSON.stringify(payload)));

	const key = await crypto.subtle.importKey('raw', enc.encode(secret), { name: 'HMAC', hash: 'SHA-256' }, false, ['sign']);
	const sig = await crypto.subtle.sign('HMAC', key, enc.encode(`${headerB64}.${payloadB64}`));

	return `${headerB64}.${payloadB64}.${base64url(sig)}`;
}

export function replaceHelpjuiceLocale(url, locale) {
	if (locale === 'en-GB') locale = 'en-US';

	const u = new URL(url);
	const parts = u.pathname.split('/').filter(Boolean);

	if (parts.length > 0 && /^[a-z]{2}_[A-Z]{2}$/.test(parts[0])) {
		parts[0] = locale.replace('-', '_');
		u.pathname = '/' + parts.join('/');
	}

	return u.toString();
}
